/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDocumented } from '../../models/paginated-documented';
import { PianificazioneResDto } from '../../models/pianificazione-res-dto';

export interface PianificazioniControllerFindManyPianificazione$Params {
  /**
   * Page number to retrieve. If you provide invalid value the default page number will applied
   *
   * **Example:** 1
   *
   *
   * **Default Value:** 1
   */
  page?: number;

  /**
   * Number of records per page.
   *
   *
   * **Example:** 20
   *
   *
   *
   * **Default Value:** 20
   *
   *
   *
   * **Max Value:** 0
   *
   *
   * If provided value is greater than max value, max value will be applied.
   */
  limit?: number;

  /**
   * Filter by id query param.
   *
   * **Format:** filter.id={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.id=$eq:John Doe&filter.id=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.id'?: Array<string>;

  /**
   * Filter by stato.id query param.
   *
   * **Format:** filter.stato.id={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.stato.id=$eq:John Doe&filter.stato.id=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.stato.id'?: Array<string>;

  /**
   * Filter by dal query param.
   *
   * **Format:** filter.dal={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.dal=$eq:John Doe&filter.dal=$gte:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gte
   *
   * - $lte
   *
   * - $and
   *
   * - $or
   */
  'filter.dal'?: Array<string>;

  /**
   * Filter by al query param.
   *
   * **Format:** filter.al={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.al=$eq:John Doe&filter.al=$gte:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gte
   *
   * - $lte
   *
   * - $and
   *
   * - $or
   */
  'filter.al'?: Array<string>;

  /**
   * Parameter to sort by.
   * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
   *
   * **Format:** {fieldName}:{DIRECTION}
   *
   *
   * **Example:** sortBy=id:DESC&sortBy=organizzazione.id:DESC
   *
   *
   * **Default Value:** id:ASC
   *
   * **Available Fields**
   * - id
   *
   * - organizzazione.id
   *
   * - persona.id
   *
   * - dal
   *
   * - al
   *
   * - stato.id
   */
  sortBy?: Array<
    | 'id:ASC'
    | 'id:DESC'
    | 'organizzazione.id:ASC'
    | 'organizzazione.id:DESC'
    | 'persona.id:ASC'
    | 'persona.id:DESC'
    | 'dal:ASC'
    | 'dal:DESC'
    | 'al:ASC'
    | 'al:DESC'
    | 'stato.id:ASC'
    | 'stato.id:DESC'
  >;

  /**
   * Search term to filter result values
   *
   * **Example:** John
   *
   *
   * **Default Value:** No default value
   */
  search?: string;

  /**
   * List of fields to search by term to filter result values
   *
   * **Example:** id,organizzazione.id,persona.id,dal,al
   *
   *
   * **Default Value:** By default all fields mentioned below will be used to search by term
   *
   * **Available Fields**
   * - id
   *
   * - organizzazione.id
   *
   * - persona.id
   *
   * - dal
   *
   * - al
   *
   * - stato.id
   */
  searchBy?: Array<string>;
}

export function pianificazioniControllerFindManyPianificazione(
  http: HttpClient,
  rootUrl: string,
  params?: PianificazioniControllerFindManyPianificazione$Params,
  context?: HttpContext,
): Observable<
  StrictHttpResponse<
    PaginatedDocumented & {
      data?: Array<PianificazioneResDto>;
      meta?: {
        select?: Array<string>;
        filter?: {
          id?: string | Array<string>;
          'stato.id'?: string | Array<string>;
          dal?: string | Array<string>;
          al?: string | Array<string>;
        };
      };
    }
  >
> {
  const rb = new RequestBuilder(
    rootUrl,
    pianificazioniControllerFindManyPianificazione.PATH,
    'get',
  );
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.id', params['filter.id'], {});
    rb.query('filter.stato.id', params['filter.stato.id'], {});
    rb.query('filter.dal', params['filter.dal'], {});
    rb.query('filter.al', params['filter.al'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<
          PaginatedDocumented & {
            data?: Array<PianificazioneResDto>;
            meta?: {
              select?: Array<string>;
              filter?: {
                id?: string | Array<string>;
                'stato.id'?: string | Array<string>;
                dal?: string | Array<string>;
                al?: string | Array<string>;
              };
            };
          }
        >;
      }),
    );
}

pianificazioniControllerFindManyPianificazione.PATH = '/admin/pianificazioni';
